import axios from 'axios';

export const baseUrl = "https://stage-apiv2.myearth.id";
const ADMIN_KEY = "Rejolut@1008";
const DEFAULT_WEBHOOK = "http://localhost:3000/user/getUser";

// Axios instance
const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// Safe request handler with logs
const handleRequest = async (fn, endpointName = '') => {
  try {
    console.log(`🔁 API Call Initiated: ${endpointName}`);
    const res = await fn();
    console.log(`✅ API Call Success: ${endpointName}`, res.data);
    return res.data;
  } catch (e) {
    console.error(`❌ API Call Failed: ${endpointName}`, {
      status: e?.response?.status,
      message: e?.response?.data?.message,
      data: e?.response?.data
    });
    return {
      success: false,
      status: e?.response?.status || 500,
      message: e?.response?.data?.message || 'Unexpected error',
      data: e?.response?.data || null
    };
  }
};

// ✅ Partner Registration
export async function registerPartnerAuth(data, phone) {
  const payload = {
    ...data,
    adminKey: ADMIN_KEY,
    phone
  };
  console.log("📦 Payload (registerPartnerAuth):", payload);
  return handleRequest(() =>
    axiosInstance.post('/partner/registerPartner', payload),
    'registerPartnerAuth'
  );
}

// ✅ Customer Registration
export async function registerCustomerAuth(data, phone) {
  const payload = {
    ...data,
    adminKey: ADMIN_KEY,
    phone,
    webhook_url: DEFAULT_WEBHOOK,
    docsRequired: ["ID", "DL"],
    partnerOrgId: data.partnerId
  };
  console.log("📦 Payload (registerCustomerAuth):", payload);
  return handleRequest(() =>
    axiosInstance.post('/customer/registerVendor', payload),
    'registerCustomerAuth'
  );
}

// ✅ Login
export async function login(data) {
  console.log("📦 Payload (login):", data);
  return handleRequest(() =>
    axiosInstance.post('/admin/login', data),
    'login'
  );
}

// ✅ Set Password
export async function setPassword(data, email) {
  const payload = {
    ...data,
    email
  };
  console.log("📦 Payload (setPassword):", payload);
  return handleRequest(() =>
    axiosInstance.post('/partner/setPassword', payload),
    'setPassword'
  );
}

// ✅ Get User Info
export async function getMe() {
  const jwt = localStorage.getItem('jwt');
  return handleRequest(() =>
    axiosInstance.get('/dashboard/getMe', {
      headers: { jwt }
    }),
    'getMe'
  );
}

// ✅ Update Profile
export async function updateProfile(data, jwt) {
  console.log("📦 Payload (updateProfile):", data);
  return handleRequest(() =>
    axiosInstance.post('/admin/updateProfile', data, {
      headers: { jwt }
    }),
    'updateProfile'
  );
}

// ✅ Forgot Password
export async function forgotPassword(email) {
  console.log("📧 Email (forgotPassword):", email);
  return handleRequest(() =>
    axiosInstance.post('/admin/sendForgotPWDEmail', { email }),
    'forgotPassword'
  );
}

// ✅ Set New Password
export async function setForgotPassword(token, password, confirmPassword) {
  const payload = {
    newPassword: password,
    newConfirmPassword: confirmPassword
  };
  console.log("🔁 Token (setForgotPassword):", token);
  console.log("📦 Payload (setForgotPassword):", payload);
  return handleRequest(() =>
    axiosInstance.post(`/admin/forgotPassword?token=${token}`, payload),
    'setForgotPassword'
  );
}
